import React, { useRef } from "react";
import useMovement from "../hooks/useMovement";

// This component enables movement by swiping or dragging anywhere on the screen (mobile only)
const MobileMovementController = ({ currentMode }) => {
  const movement = useMovement({ currentMode });
  const startRef = useRef(null);
  const lastDirectionRef = useRef(null);
  const threshold = 20; // Minimum px to trigger movement

  // Helper to trigger keyboard events programmatically
  const triggerKey = (key, type = "keydown") => {
    const event = new KeyboardEvent(type, { key });
    window.dispatchEvent(event);
  };

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    startRef.current = { x: touch.clientX, y: touch.clientY };
    lastDirectionRef.current = null;
  };

  const handleTouchMove = (e) => {
    if (!startRef.current) return;
    const touch = e.touches[0];
    const dx = touch.clientX - startRef.current.x;
    const dy = touch.clientY - startRef.current.y;
    let direction = null;
    if (Math.abs(dx) > Math.abs(dy)) {
      if (dx > threshold) direction = "ArrowRight";
      else if (dx < -threshold) direction = "ArrowLeft";
    } else {
      if (dy > threshold) direction = "ArrowDown";
      else if (dy < -threshold) direction = "ArrowUp";
    }
    if (direction && lastDirectionRef.current !== direction) {
      // Stop previous direction
      if (lastDirectionRef.current) triggerKey(lastDirectionRef.current, "keyup");
      // Start new direction
      triggerKey(direction, "keydown");
      lastDirectionRef.current = direction;
    }
    // If moved back to center, stop movement
    if (!direction && lastDirectionRef.current) {
      triggerKey(lastDirectionRef.current, "keyup");
      lastDirectionRef.current = null;
    }
  };

  const handleTouchEnd = () => {
    if (lastDirectionRef.current) {
      triggerKey(lastDirectionRef.current, "keyup");
      lastDirectionRef.current = null;
    }
    startRef.current = null;
  };

  return (
    <div
      className="mobileMovementController"
      style={{
        position: "fixed",
        // top: "4rem",
        // left: "3rem",
        // height: "calc(100% - 10rem)",
        inset: '4rem 0rem 4rem 3rem',
        zIndex: 1000,
        touchAction: "none",
        background: "rgba(0,0,0,0)", // transparent overlay
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchEnd}
    >
      {/* Optionally, add a visual hint for the user */}
      {/* <div style={{position:'absolute',bottom:20,left:0,right:0,textAlign:'center',color:'#fff'}}>Swipe to move</div> */}
    </div>
  );
};

export default MobileMovementController;
